// eslint-disable-next-line no-restricted-imports
import CarinaIcon from '@cvent/carina-v2/components/Icon';

import { DEFAULT_ICON_PACK } from '@cvent/carina-v2/components/IconProvider/IconProvider';
import { useThemeValues } from '@context/ThemeProvider';

export const iconPacks = {
  carina: true,
  thin: true,
  bold: true,
  sharp: true,
  heavy: true,
  round: true
};

export type IconProps = React.ComponentProps<typeof CarinaIcon> & {
  respectThemeSettings?: boolean;
};

/**
 * Wrapper around the Carina Icon component.
 * Using this component guarantees that all icons respect the icon theme settings defined in `themeSettings.icons` and icons usage stays consistent.
 */
function Icon({ name, size = 'xs', respectThemeSettings = true, ...propDrop }: IconProps) {
  const { icons } = useThemeValues();

  if (!respectThemeSettings) {
    return <CarinaIcon name={name} size={size} pack={DEFAULT_ICON_PACK} {...propDrop} />;
  }

  if (icons?.reassignedIconsLookup) {
    const reassignedIcon = icons.reassignedIconsLookup[name];

    if (reassignedIcon) {
      return <CarinaIcon name={reassignedIcon} size={size} {...propDrop} />;
    }
  }

  return <CarinaIcon name={name} size={size} {...propDrop} />;
}

export default Icon;
